export const TAP = { scale: 0.98 };

export const fadeUp = (delay = 0, { y = 24, duration = 0.6 } = {}) => ({
  initial: { opacity: 0, y },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration, delay },
});

export const fadeIn = (delay = 0, duration = 0.9) => ({
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true },
  transition: { duration, delay },
});
